const isPrimitive = val =>
    typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean';

// total body description limit is around 32k but we need to leave some space for other fields
export const JIRA_HTML_SIZE_LIMIT = 25000;

export function buildJiraAdfTable(headers, rows) {
    // Helper: create a paragraph content with optional link marks
    const createParagraphContent = cell => [{ type: 'text', text: cell.toString() }];

    // Build header row
    const headerRow = {
        type: 'tableRow',
        content: headers.map(header => ({
            type: 'tableHeader',
            content: [
                {
                    type: 'paragraph',
                    content: createParagraphContent(header),
                },
            ],
        })),
    };

    // Build data rows
    const dataRows = rows.map(row => ({
        type: 'tableRow',
        content: row.map(cell => {
            const cellContent = {
                type: 'tableCell',
                content: [],
            };
            if (isPrimitive(cell)) {
                cellContent.content.push({
                    type: 'paragraph',
                    content: createParagraphContent(cell),
                });
            } else cellContent.content.push(cell);
            return cellContent;
        }),
    }));

    const tableNode = {
        type: 'table',
        content: [headerRow, ...dataRows],
    };
    return tableNode;
}

export function buildBulletListAdf(items) {
    return {
        type: 'bulletList',
        content: items.map(listItem => {
            let listItemContent;

            listItemContent = {
                type: 'paragraph',
                content: [],
            };

            if (isPrimitive(listItem)) {
                listItemContent.content.push({
                    type: 'text',
                    text: listItem.toString(),
                });
            } else {
                listItemContent.content.push(listItem);
            }
            return {
                type: 'listItem',
                content: [listItemContent],
            };
        }),
    };
}

export function buildCodeBlockAdf(code, language = 'javascript') {
    return {
        type: 'codeBlock',
        attrs: {
            language,
        },
        content: [
            {
                type: 'text',
                text: code,
            },
        ],
    };
}

export function headingAdf(headeringText, level = 3) {
    return {
        type: 'heading',
        attrs: {
            level,
        },
        content: [
            {
                type: 'text',
                text: headeringText,
            },
        ],
    };
}

export function formattedText(text, marksType = null, withoutParagraph = false) {
    const paragraphContainer = {
        type: 'paragraph',
        content: [],
    };

    const textNode = {
        type: 'text',
        text,
        ...(marksType ? { marks: [{ type: marksType }] } : {}),
    };
    if (withoutParagraph) {
        return textNode;
    }
    paragraphContainer.content.push(textNode);
    return paragraphContainer;
}

export function subHeadingWithTextAdf(subheading, description, href = null) {
    return {
        type: 'paragraph',
        content: [
            {
                type: 'text',
                text: subheading,
                marks: [{ type: 'strong' }],
            },
            { type: 'text', text: ': ' },
            {
                type: 'text',
                text: description.toString(),
                ...(href && {
                    marks: [
                        {
                            type: 'link',
                            attrs: {
                                href,
                            },
                        },
                    ],
                }),
            },
        ],
    };
}

export function buildLinkAdf(text, href, withoutParagraph = false) {
    const paragraphContainer = {
        type: 'paragraph',
        content: [],
    };
    const linkNode = {
        type: 'text',
        text,
        marks: [
            {
                type: 'link',
                attrs: {
                    href,
                },
            },
        ],
    };

    if (withoutParagraph) {
        return linkNode;
    }
    paragraphContainer.content.push(linkNode);
    return paragraphContainer;
}
